import { ChatBot } from './ChatBot.js';

window.customElements.define('chat-bot', ChatBot);
